export const KEYS = {
  ORDER_BOOK: (symbol: string) => `/orderbooks/${String(symbol).toUpperCase()}`,
  ORDER_BOOK_SPREADS: () => `/orderbooks/spreads`,
  TRADES: (symbol: string) => `/trades/${String(symbol).toUpperCase()}`,
};
